import { ImResponse, resolve, storeHomeNVClient } from 'services/api';

export interface StatListBody {
  orgId: number;
  receptionType: Dashboard.ReceptionScore.ReceptionType;
  platform?: General.PlatformUpperCase;
  storeType?: Dashboard.ReceptionScore.StoreType;
  assistantIds?: string[];
  storeIds?: string[];
  startTime: number;
  endTime: number;
}

export function statList(body: StatListBody) {
  return resolve(
    storeHomeNVClient.post<ImResponse<{ data: Dashboard.ReceptionScore.Stat[] }>>(
      '/api_gateway/dashboard/reception-score/stats',
      { ...body, timeBasis: 'INVITE_TIME', responseVersion: 2 },
    ),
  ).then(({ data }) => data);
}

export interface AssistantDetailListBody
  extends Pick<StatListBody, 'platform' | 'storeType' | 'storeIds' | 'startTime' | 'endTime'> {
  assistantIds: string[];
  replyOption?: Dashboard.ReceptionScore.ReplyOption;
  scoreType?: 'POSITIVE' | 'NEGATIVE';
  reasonCode?: string;
  pageNo: number;
  pageSize: number;
}

export interface AssistantDetailListResponse {
  data: Dashboard.ReceptionScore.AssistantDetail[];
  pageInfo: {
    pageNo: number;
    pageSize: number;
    totalCount: number;
  };
}

export function assistantDetailList(body: AssistantDetailListBody) {
  return resolve(
    storeHomeNVClient.post<ImResponse<AssistantDetailListResponse>>(
      '/api_gateway/dashboard/reception-score/list',
      {
        ...body,
        replyOption: undefined,
        scoreType:
          body.scoreType ||
          (body.replyOption === '1'
            ? 'POSITIVE'
            : body.replyOption === '2'
            ? 'NEGATIVE'
            : undefined),
        timeBasis: 'INVITE_TIME',
        responseVersion: 2,
      },
    ),
  );
}

export interface ScoreDetailBody {
  id: number;
}

export function scoreDetail(body: ScoreDetailBody) {
  return resolve(
    storeHomeNVClient.post<ImResponse<Dashboard.ReceptionScore.ScoreDetail>>(
      '/api_gateway/dashboard/reception-score/detail',
      { ...body, timeBasis: 'INVITE_TIME', responseVersion: 2 },
    ),
  );
}

export interface ExportStatsBody extends StatListBody {
  language: General.SystemLanguage;
}

export function exportStats(body: ExportStatsBody) {
  return resolve(
    storeHomeNVClient.post<ImResponse<string>>(
      '/api_gateway/dashboard/reception-score/stats/export',
      { ...body, timeBasis: 'INVITE_TIME', responseVersion: 2 },
    ),
  );
}

export interface ExportAssistantDetailsBody
  extends Omit<AssistantDetailListBody, 'pageNo' | 'pageSize'> {
  language: General.SystemLanguage;
}

export function exportAssistantDetails(body: ExportAssistantDetailsBody) {
  return resolve(
    storeHomeNVClient.post<ImResponse<string>>(
      '/api_gateway/dashboard/reception-score/list/export',
      { ...body, timeBasis: 'INVITE_TIME', responseVersion: 2 },
    ),
  );
}
